module.exports = __webpack_public_path__ + "img/logo-britecheck.61b7fe08.svg";